import './assets/main.css'
import '@gohighlevel/ghl-ui/dist/style.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import './assets/ecommerce-multiselect.css'
import './assets/cac-profile.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { i18n } from './locales/i18n'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')
